import { createLocalHostApiFactory } from '../../utils/local-host';

/**
 * Tells POS to log an error screen.
 */
const logErrorScreen: () => void = createLocalHostApiFactory(() => {}, 500);

const log = {
  logErrorScreen,
};

export { log };
